import { Component, ViewEncapsulation, Input, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { Subject, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import {roundPointsInvestment, stressCalc} from '../../utils/investment-calculation';

@Component({
    selector: 'dialog-price-edition',
    templateUrl: './dialog-price-edition.component.html',
    styleUrls: ['dialog-price-edition.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogPriceEditionComponent extends DialogPanelComponentContent {

    public lotEdited: number;
    public saveEdit: Subject<number> = new Subject<number>();
    public saveManualEdit: Subject<{}> = new Subject<{}>();
    public form: FormGroup;
    public disposableSubscriptions: Subscription[] = [];
    public getInvestments: number;
    public typeMarketEnum = OrderMarketTypeEnum;

    public get isFuture() {
        return this.dialogData.typeMarket === OrderMarketTypeEnum.Future
    }

    public get stopValue(){
        return this.dialogData.priceEdited * this.dialogData.quoteFactor
    }

    public get priceVariation() {
        return this.dialogData.priceEdited / this.dialogData.buyAmount
    }

    public roundPointsInvestment(points: number) {
        return roundPointsInvestment(points);
    }


    public constructor(
        public elementRef: ElementRef,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private dialogReference: MatDialogRef<DialogPriceEditionComponent>,
        private formBuilder: FormBuilder,
        private store: Store<AppState>,
    ) {
        super(elementRef, true);

        if (dialogData) {
            if (!dialogData.isAutomatic) {
                this.createManualForm();
            }
            this.getInvestments = this.dialogData.getInvestments;
        } else {
            this.closeDialog();
        }
        this.bindQuoteSubscription();
    }

    public createManualForm() {
        this.form = this.formBuilder.group({
            customPrice: [this.dialogData.editedPrice ? this.dialogData.editedPrice : this.dialogData.unitPrice, Validators.required],
            isBetterPrice: !this.dialogData.editedPrice ? true : false,
        });
    }

    public closeDialog() {
        this.close(this.dialogReference, null);
        this.dialogReference = null;
    }

    public get moneyDirection() {
        return !!this.dialogData.isGain ? 'lucro' : 'prejuízo';
    }

    public getLotsByChip(lots) {
        this.lotEdited += lots;
    }

    public getPriceByChip(price) {
        if (this.dialogData.priceEdited + price > 0) {
            // VERIFICAR - Valor retornado na variavel price
            this.dialogData.priceEdited += (price / this.dialogData.quoteFactor);
        }
    }

    // Salva as alterações de preço
    public save() {
        this.closeDialog();
        if(this.isFuture){
            return this.saveEdit.next(this.stopValue);
        }
        
        if (this.dialogData.isDayTrade || !this.dialogData.purchase) {
            this.saveEdit.next(
                this.stopValue / stressCalc(this.dialogData.purchase, this.dialogData.stress.value, this.dialogData.stress.dayTradeValue, this.dialogData.isDayTrade, this.dialogData.typeMarket));
        } else {
            this.saveEdit.next(this.stopValue);
        }
    }

    public saveManual() {
        this.closeDialog();
        const isBetterPrice: boolean = this.form.get('isBetterPrice').value;
        this.saveManualEdit.next({
            isBetterPrice: isBetterPrice,
            value: !isBetterPrice ? this.form.get('customPrice').value : this.dialogData.unitPrice,
        });
    }

    public get inputPriceSuffix(): string {
        if (this.dialogData.typeMarket === OrderMarketTypeEnum.Future) return ' pts';

        return '';
    }

    private bindQuoteSubscription() {
        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.quote)
                .filter((item) => item[this.dialogData.stockId])
                .map((item) => item[this.dialogData.stockId])
                .subscribe((quote) => {
                    this.dialogData.unitPrice =
                        quote.PriceLastTrade ||
                        quote.OpeningPrice ||
                        quote.ClosingPricePreviousDay ||
                        quote.priceLastTrade ||
                        quote.openingPrice ||
                        quote.closingPricePreviousDay;
                }),
        );
    }
}
